(function () {
    'use strict';

    angular.module('swif.parcauto').config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/parcauto/wizard', {
            templateUrl: 'partials/parcauto/wizard_view.html',
            controller: 'OpenbaseWizardController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }])

    .controller('ParcautoWizardBrand', [
        '$scope', 'swifFrameworkService', '$http', '$q', 'openbaseWizardService',
        function ($scope, swif, $http, $q, wizard) {
            $scope.contentType = 'parcauto_brand';
            $scope.heads = 'Nom';
            $scope.items = {};
            //fields of the object
            $scope.fields = ['name'];
            //fields for import params
            var fields = ['id', 'name'];
            wizard.load_json($scope.items, 'json/wizard_parcauto_brand.json');
            $scope.import_data = function () {
                swif.message.loading($scope.loading.import);
                var data = wizard.pre_import_data($scope.items.selected, fields);
                wizard.import_data($scope.contentType, fields, data)
                .then(function () {
                    swif.message.loading($scope.loading.import, 'ok');
                    swif.message.addInfo('data imported successfully');
                });
            };
        }
    ])
    .controller('ParcautoWizardBrandModel', [
        '$scope', 'swifFrameworkService', '$http', '$q', 'openbaseWizardService',
        function ($scope, swif, $http, $q, wizard) {
            $scope.contentType = 'parcauto_model';
            $scope.heads = 'Nom,Long,Largeur,Hauteur,Weight PTC,Weight PTAC,Weight PTR';
            $scope.items = {};
            //fields of the object
            $scope.fields = ['name', 'width','height','length','weight_ptv','weight_ptac','weight_ptr'];
            //fields for import params
            var fields = ['name','width','height','length','weight_ptv','weight_ptac','weight_ptr','brand_id/id'];
            wizard.load_json($scope.items, 'json/wizard_parcauto_brand_model.json');
            $scope.import_data = function () {
                swif.message.loading($scope.loading.import);
                var cfields = angular.copy($scope.fields);
                cfields.push('brand_id');
                var data = wizard.pre_import_data($scope.items.selected, cfields);
                wizard.import_data($scope.contentType, fields, data)
                .then(function () {
                    swif.message.loading($scope.loading.import, 'ok');
                    swif.message.addInfo('data imported successfully');
                });
            };
        }
    ])
    .controller('ParcautoWizardCategory', [
        '$scope', 'swifFrameworkService', '$http', '$q', 'openbaseWizardService',
        function ($scope, swif, $http, $q, wizard) {
            $scope.contentType = 'parcauto_type';
            $scope.heads = 'Nom';
            $scope.items = {};
            //fields of the object
            $scope.fields = ['name', 'description'];
            //fields for import params
            var fields = ['name', 'description'];
            wizard.load_json($scope.items, 'json/wizard_absence_categories.json');
            $scope.import_data = function () {
                swif.message.loading($scope.loading.import);
                var data = wizard.pre_import_data($scope.items.selected, $scope.fields);
                wizard.import_data($scope.contentType, fields, data)
                .then(function () {
                    swif.message.loading($scope.loading.import, 'ok');
                    swif.message.addInfo('data imported successfully');
                });
            };
        }
    ])
    .controller('ParcautoWizardFuel', [
        '$scope', 'swifFrameworkService', '$http', '$q', 'openbaseWizardService',
        function ($scope, swif, $http, $q, wizard) {
            $scope.contentType = 'parcauto_fuel';
            $scope.heads = 'Nom';
            $scope.items = {};
            //fields of the object
            $scope.fields = ['name'];
            //fields for import params
            var fields = ['name'];
            wizard.load_json($scope.items, 'json/wizard_task_categories.json');
            $scope.import_data = function () {
                swif.message.loading($scope.loading.import);
                var data = wizard.pre_import_data($scope.items.selected, $scope.fields);
                wizard.import_data($scope.contentType, fields, data)
                .then(function () {
                    swif.message.loading($scope.loading.import, 'ok');
                    swif.message.addInfo('data imported successfully');
                });
            };
        }
    ]);

})();
